import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './WhatsAppButton.scss';

const WhatsAppButton = () => {
  const { t } = useTranslation();
  const phoneNumber = '5442379237';
  const message = t('whatsapp.message');
  
  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <motion.div
      className="whatsapp-button"
      onClick={handleWhatsAppClick}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1, duration: 0.5 }}
    >
      <MessageCircle size={28} />
      <span className="tooltip">{t('whatsapp.tooltip')}</span>
    </motion.div>
  );
};

export default WhatsAppButton; 